import { get, toLower } from 'lodash'

const EMPTY_OBJECT = {}
const EMPTY_ARRAY = []

const user = (state = {}) => get(state, 'auth.current.user', EMPTY_OBJECT)
const tenant = (state = {}) => get(state, 'auth.current.tenant', EMPTY_OBJECT)
const customer = (state = {}) => get(state, 'auth.current.customer', EMPTY_OBJECT)
const menuItems = (state = {}) => get(state, 'auth.current.menuItems', EMPTY_ARRAY)
const tenantTypeIsDcrib = (state = {}) => toLower(tenant(state).tenantType) === 'dcrib'
const userIsInRoleDistributor = (state = {}) => user(state).userIsInRoleDistributor
const userIsInRoleStaff = (state = {}) => user(state).userIsInRoleStaff

export default {
  user,
  tenant,
  customer,
  menuItems,
  userIsInRoleStaff,
  tenantTypeIsDcrib,
  userIsInRoleDistributor,
  logo: (state = {}) => state.auth?.current?.logo,
  locale: (state = {}) => get(user(state), 'languageCode', 'en'),
  locales: (state = {}) => state.i18n?.locales ?? [],
  impersonator: (state = {}) => state.auth?.impersonator,
  ssoLogoutUrl: (state = {}) => state?.auth?.current?.ssoLogoutUrl,
  userIsInRoleSupplier: (state = {}) => user(state).userIsInRoleSupplierAdmin,
  userIsDcribCustomer: (state = {}) => tenantTypeIsDcrib(state) && !userIsInRoleDistributor(state),
  userIsDcribDistributor: (state = {}) => tenantTypeIsDcrib(state) && userIsInRoleDistributor(state),
  tenantTypeIsTrms: (state = {}) => toLower(tenant(state).tenantType) === 'trms',
  tenantGroupIsCardinal: (state = {}) => toLower(user(state).tenantGroup) === 'cardinal',
  enableAssetManagement: (state = {}) => get(customer(state), 'moduleSettings.enableAssetManagement'),
  allowedFileTemplateTypes: (state = {}) => get(state, 'auth.current.allowedFileTemplateTypes', {}),
  tenantIsFnl: (state = {}) => ['fnlsafety', 'fnlaudit'].includes(toLower(tenant(state).subdomain)),
  useInventoryBarcode: (state = {}) => get(customer(state), 'generalSettings.useInventoryBarcode'),
}
